<template>
  <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
        <form>
          <!-- <div class="p-grid">
            <div class="p-col">
              <Button class="p-button-raised p-button-rounded" @click.prevent="openAddDialog"
               icon="pi pi-plus" style="float:right;"/>
            </div>
          </div> -->
          <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openAddDialog" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
          <Dialogs  header="Clinet Details"  :visible.sync="addDisplayBasic" :style="{width: '50vw'}"
          :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <label for="name" >Name<span style="color:red">*</span></label>
                <InputText id="name" v-model.trim="clientName" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="address" >Address<span style="color:red">*</span></label>
                <InputText id="address" v-model.trim="address" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="primaryContactNumber" >Contact Number</label>
                <InputText @keypress="isNumber($event)" v-model="primaryContactNumber" id="primaryContactNumber"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="sec">Secondary Contact Number</label>
                <InputText  v-model.trim="secondaryContactNumber" id="sec"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="email" >Email</label>
                <InputText v-model.trim="email" id="email" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="product" >Product</label>
                <InputText v-model.trim="product" id="product" />
              </div>
              
               <div class="p-field p-col-12 p-md-6">
                <label for="product" >Agreement Amount</label>
                <InputText v-model.trim="product" id="product" />
              </div>
               <div class="p-field p-col-12 p-md-6">
                <label for="product" >Agreement Date</label>
                <InputText v-model.trim="product" id="product" />
              </div>

             <div class="p-field p-col-12 p-md-6">
                <label for="status1" >Status</label>
                <div class="p-field p-col-12 p-md-6">
                  <RadioButton id="status1" name="ACTIVE" value="ACTIVE" v-model="status" />
                  <label for="status1">Active</label>
                  <RadioButton id="status2" name="INACTIVE" value="INACTIVE" v-model="status" />
                  <label for="status2">Inactive</label>
                </div>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="description">Description</label>
                <!-- <Textarea id="description" rows="3" v-model="description"/> -->
                <textarea type="text" rows="3" class="form-control" v-model="description"/>
              </div>   
              <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised" @click.prevent="editPersonalInfo()" label="Contact Details"/>
              </div>               
    
      </div>
      <template #footer>
        <Button class="p-button-raised" @click.prevent="addCustomer" :label="editing?'Update':'Add'"/>
        <!-- <Button class="p-button-raised p-button-primary" label="Add & New" @click.prevent="addAndNewClient" v-if="!editing"/> -->
        <Button  @click.prevent="addCancel" class="p-button-raised p-button-danger" label="Cancel"/>
      </template>
      </Dialogs>
      <Dialogs  header="Clinet Contact Details"  :visible.sync="addPersonalDisplayBasic" :style="{width: '50vw'}"
          :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <label for="contactName" >Name<span style="color:red">*</span></label>
                <InputText id="contactName" v-model.trim="contactName" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="address" >Address<span style="color:red">*</span></label>
                <InputText id="contactAddress" v-model.trim="contactAddress" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="contactPrimaryContactNumber" >Contact Number</label>
                <InputText @keypress="isNumber($event)" v-model="contactPrimaryContactNumber" id="contactPrimaryContactNumber"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="conSec">secondary Contact Number</label>
                <InputText @keypress="isNumber($event)" v-model="contactSecondaryContactNumber" id="conSec"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="contactEmail" >Email</label>
                <InputText v-model.trim="contactEmail" id="contactEmail" />
              </div>

               <div class="p-field p-col-12 p-md-6">
                <label for="designation" >Designation</label>
                <InputText v-model.trim="designationId" id="designationId" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="conDescription">Description</label>
                <!-- <Textarea id="conDescription" rows="3" v-model="contactDescription"/> -->
                <textarea type="text" rows="2" class="form-control" v-model="contactDescription"/>
              </div> 

      </div>
      <template #footer>
        <Button class="p-button-raised" @click.prevent="closeAddPersonalInfoDialog" label="Save"/>
      <Button  @click.prevent="cancelAddPersonalInfoDialog" class="p-button-raised p-button-danger" label="Cancel"/>
      </template>
      </Dialogs>
    </form>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import RadioButton from 'primevue/radiobutton'
import Dialogs from 'primevue/dialog'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Textarea from 'primevue/textarea'
export default {
  name: 'supplier',
  data() {
    return {
      clientName: '',
      address: '',
      primaryContactNumber: '',
      secondaryContactNumber: '',
      email: '',
      description: '',
      contactName: '',
      contactAddress: '',
      contactPrimaryContactNumber: '',
      contactSecondaryContactNumber: '',
      contactEmail: '',
      designationId: '',
      contactDescription: '',
      dialogShow: false,
      addDisplayBasic: false,
      addPersonalDisplayBasic: false,
      addDialog: false,
      editing: false,
      status: 'ACTIVE',
      id: '',
      loading: false,
      columnList: '',
      filters: {},
      crmClientPersonalInfoDTOList: []
    }
  },
  methods: {
    async addCustomer() {
      if (this.clientName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.address === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'address cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        id: this.id,
        clientName: this.clientName,
        address: this.address,
        primaryContactNumber: this.primaryContactNumber,
        secondaryContactNumber: this.secondaryContactNumber,
        email: this.email,
        status: this.status,
        clientType: 'Customer',
        crmClientPersonalInfoDTOList: this.crmClientPersonalInfoDTOList
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createCrmCustomer', accountMaster)
        // this.$emit('set_supplier_master', resp.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateCrmCustomer', accountMaster)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeAddDialog()
    },
    async addAndNewClient() {
      if (this.clientName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.address === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'address cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        clientName: this.clientName,
        address: this.address,
        primaryContactNumber: this.primaryContactNumber,
        secondaryContactNumber: this.secondaryContactNumber,
        email: this.email,
        status: this.status,
        clientType: 'Customer',
        crmClientPersonalInfoDTOList: this.crmClientPersonalInfoDTOList

      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createCrmCustomer', accountMaster)
      this.loading = false
      this.responseMessage(resp)
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
        this.editing = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    addPersonalInfoDetails() {
      let item = {
        name: this.contactName,
        address: this.contactAddress,
        contactNumber: this.contactPrimaryContactNumber,
        secondaryContactNumber: this.contactSecondaryContactNumber,
        email: this.contactEmail,
        remarks: this.contactDescription,
        id: this.id,
        clientId: this.clientId
      }
      if (!this.editDto) {
        this.crmClientPersonalInfoDTOList.push({...item})
      } else {
        this.crmClientPersonalInfoDTOList.splice(this.index, 1, {...item})
      }
      this.itemDTOreset()
      this.focusInput()
    },
    editPersonalInfo() {
      const data = {
        id: this.id,
        name: this.clientName,
        address: this.address,
        contactNumber: this.primaryContactNumber,
        secondaryContactNumber: this.secondaryContactNumber,
        email: this.email,
        remarks: this.description
      }
      console.log(data)
      this.addDisplayBasic = false
      this.openAddPersonalInfoDialog()
    },
    editCrmCustomer(data) {
      this.editing = true
      this.addDisplayBasic = false
      this.id = data.id
      this.clientName = data.clientName
      this.address = data.address
      this.primaryContactNumber = data.primaryContactNumber
      this.secondaryContactNumber = data.secondaryContactNumber
      this.email = data.email
      this.description = data.description
      this.openAddDialog()
    },
    resetPersonalInfo() {
      this.contactName = ''
      this.contactAddress = ''
      this.contactPrimaryContactNumber = ''
      this.contactSecondaryContactNumber = ''
      this.contactEmail = ''
      this.contactDescription = ''
    },
    reset() {
      this.clientName = ''
      this.address = ''
      this.primaryContactNumber = ''
      this.secondaryContactNumber = ''
      this.email = ''
      this.status = ''
      this.status = 'ACTIVE'
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeAddPersonalInfoDialog() {
      this.addPersonalDisplayBasic = false
    },
    cancelAddPersonalInfoDialog() {
      this.resetPersonalInfo()
      this.addPersonalDisplayBasic = false
    },
    openAddPersonalInfoDialog() {
      this.addPersonalDisplayBasic = true
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    closeAddDialog() {
      this.addDisplayBasic = false
    },
    addCancel() {
      this.reset()
      this.resetPersonalInfo()
      this.closeAddDialog()
    }
  },
  components: {
    Dropdown,
    RadioButton,
    Dialogs,
    Toast,
    Button,
    InputText,
    InputMask,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// crmCustomerdialog.vue?5cea68ed